<template>
  <container id='video' num='04' title='养殖基地'>
    <div :class='$style.container'>
      <video :class='$style.video' controls width='100%'>
        <source src='https://www.guanaoxiefu.com/guanao.mp4' />
      </video>
    </div>
  </container>
</template>

<script>
import Container from "./Container";
export default {
  name: "Video",
  components: { Container }
};
</script>

<style lang='scss' module>
@import "../tool";
.container {
  padding-bottom: 72px;
}
</style>